import styled from 'styled-components'

export const StyledApp = styled('div')`
position: relative;
background-color: rgba(20,20,20,1);
`